import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../AxiosInterceptor/axiosInterceptor';

const initialState = {
    carrierList: [],
    loading: false,
    error: null,
    selectedCarriers: []
};

export const fetchReportsCarriers = createAsyncThunk('reportsCarrier/fetchReportsCarriers',
    async (_, { rejectWithValue }) => {
        try {
            const query = `query GetCarrierData {\n        GetCarrierData{\n          data {\n            CarrierDescription\n            Carrier\n            CocaGroup\n            CocaGroupDescription\n          }\n          message\n          success\n        }\n      }`;
            const endpoint = process.env.REACT_APP_REPORTS_CARRIER_API;
            const response = await axiosInstance.post(endpoint, JSON.stringify({ query, variables: {} }));
            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }
            const result = response.data.data?.GetCarrierData;
            if (!result?.success) {
                return rejectWithValue(result?.message || 'GetCarrierData unsuccessful');
            }
            const carrierData = (result.data || []).reduce((acc, item) => {
                if (!item.Carrier) return acc;
                if (!acc.find(c => c.carrier === item.Carrier)) {
                    acc.push({
                        carrier: item.Carrier,
                        carrierDescription: item.CarrierDescription || item.Carrier,
                        cocaGroup: item.CocaGroup || '',
                        cocaGroupDescription: item.CocaGroupDescription || ''
                    });
                }
                return acc;
            }, []);
            if (carrierData.length === 0) {
                return rejectWithValue('No carriers returned');
            }
            return carrierData;
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const reportsCarrierSlice = createSlice({
    name: 'reportsCarrier',
    initialState,
    reducers: {
        setSelectedCarriers: (state, action) => {
            state.selectedCarriers = action.payload || [];
        },
        clearSelected: (state) => {
            state.selectedCarriers = [];
        },
        // Clear both carrier list and selection on tab change
        clearCarrierData: (state) => {
            state.carrierList = [];
            state.selectedCarriers = [];
            state.error = null;
            state.loading = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchReportsCarriers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchReportsCarriers.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.carrierList = action.payload;
            })
            .addCase(fetchReportsCarriers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Carrier fetch failed';
            });
    }
});

export const { setSelectedCarriers, clearSelected, clearCarrierData } = reportsCarrierSlice.actions;
export default reportsCarrierSlice.reducer;